import script from "./OapProductIngredients.vue?vue&type=script&setup=true&lang=js"
export * from "./OapProductIngredients.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__